var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50408 11.5904L1.50456 11.5895L6.44818 1.75712C6.44826 1.75695 6.44835 1.75678 6.44843 1.75661C6.49827 1.65827 6.57445 1.57996 6.66748 1.52754L6.53996 1.77781L1.54269 11.5848L1.4568 11.7534C1.46355 11.6942 1.47963 11.6388 1.50408 11.5904ZM7.43192 1.77973L7.34416 1.60564C7.39556 1.65091 7.43992 1.70477 7.47365 1.76518L12.4364 11.5566C12.5281 11.7572 12.5168 11.927 12.4296 12.0677V11.8381V11.8118V11.6929L12.376 11.5867L7.43192 1.77973ZM11.9282 12.3381L12.1687 12.3388C12.0977 12.3721 12.0168 12.3898 11.9296 12.3898H2.01477C1.90348 12.3898 1.80205 12.3609 1.71805 12.3111L1.98687 12.3118L11.9282 12.3381Z",
    fill: "#FF5B5B",
    stroke: "#FF5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95838 8.31313C6.94945 8.31313 6.94135 8.30992 6.93454 8.30318C6.92781 8.29652 6.92676 8.29102 6.92676 8.28728V5.44772C6.92676 5.44398 6.92781 5.43848 6.93454 5.43182C6.94135 5.42509 6.94945 5.42188 6.95838 5.42188C6.96731 5.42188 6.97541 5.42509 6.98222 5.43182C6.98896 5.43848 6.99 5.44398 6.99 5.44772V8.28728C6.99 8.2989 6.9884 8.30514 6.98765 8.30742C6.98458 8.30922 6.97584 8.31313 6.95838 8.31313Z",
    fill: "#FF5B5B",
    stroke: "#FF5B5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95838 10.5517C7.25199 10.5517 7.49 10.3163 7.49 10.0258C7.49 9.73543 7.25199 9.5 6.95838 9.5C6.66477 9.5 6.42676 9.73543 6.42676 10.0258C6.42676 10.3163 6.66477 10.5517 6.95838 10.5517Z",
    fill: "#FF5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.e0a675cb7abb8c8526b2bbfc1cb5e1c3.svg";
export { ForwardRef as ReactComponent };